import {regReducer} from '../../core';
import * as a from './actions';
import * as r from 'ramda';

// example state stored under `map`
// const state = {
//     __map_1: {show: true},
// };

regReducer(a.SHOW, (state, {payload}) => {
    return r.assocPath(['map', payload, 'show'], true, state);
});

regReducer(a.HIDE, (state, {payload}) => {
    return r.assocPath(['map', payload, 'show'], false, state);
});
